import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { 
  FaHome, 
  FaUpload, 
  FaSearch, 
  FaBars, 
  FaTimes, 
  FaUser,
  FaCaretDown,
  FaPlus,
  FaBriefcase,
  FaSignOutAlt
} from 'react-icons/fa';
import { ImProfile } from "react-icons/im";

const Header = () => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [showLogoutConfirm, setShowLogoutConfirm] = useState(false);
  const [showAdminMenu, setShowAdminMenu] = useState(false);
  const navigate = useNavigate();
  const role = localStorage.getItem('role');

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  const handleLogout = () => {
    localStorage.removeItem('isAuthenticated');
    localStorage.removeItem('role');
    navigate('/login');
  };

  return (
    <header className="bg-white text-black py-4 px-6 md:px-12 lg:px-24 border-b relative">
      <div className="container mx-auto flex items-center justify-between">
        {/* Logo */}
        <div className="flex items-center">
          <a href="/" rel="noopener noreferrer">
            <img 
  src="/images/logo.jpg" 
  alt="Ambuja Foundation Logo" 
  className="mr-4 max-h-16 w-auto object-contain" 
/>
          </a>
        </div>

        {/* Desktop Navigation */}
        <nav className="hidden md:flex items-center space-x-6 font-medium">
          {/* Common Navigation Items */}
          <div className="flex items-center space-x-6">
            <Link to="/" className="flex items-center text-[#080366] hover:text-[#ed6503] transition-colors">
              <FaHome className="mr-2" />
              Home
            </Link>
            <Link to="/candidate-management" className="flex items-center text-[#080366] hover:text-[#ed6503] transition-colors">
              <FaSearch className="mr-2" />
              Candidates
            </Link>
            <Link to="/upload-resume" className="flex items-center text-[#080366] hover:text-[#ed6503] transition-colors">
              <FaUpload className="mr-2" />
              Upload Resume
            </Link>
            <Link to="/vacancies" className="flex items-center text-[#080366] hover:text-[#ed6503] transition-colors">
              <FaBriefcase className="mr-2" />
              View Vacancies
            </Link>
          </div>

          {/* Admin Menu Dropdown */}
          {role === 'superadmin' && (
            <div className="relative">
              <button
                onClick={() => setShowAdminMenu(!showAdminMenu)}
                className="flex items-center text-[#080366] hover:text-[#ed6503] transition-colors px-4 py-2 rounded-lg border border-[#080366] hover:border-[#ed6503]"
              >
                <FaUser className="mr-2" />
                Admin Menu
                <FaCaretDown className="ml-2" />
              </button>

              {showAdminMenu && (
                <div className="absolute right-0 mt-2 w-48 bg-white rounded-lg shadow-lg border border-gray-200 py-2 z-50">
                  <Link 
                    to="/profile" 
                    className="flex items-center px-4 py-2 text-[#080366] hover:bg-gray-50 hover:text-[#ed6503]"
                    onClick={() => setShowAdminMenu(false)}
                  >
                    <ImProfile className="mr-2" />
                    Add Profile
                  </Link>
                  <Link 
                    to="/add-vacancy" 
                    className="flex items-center px-4 py-2 text-[#080366] hover:bg-gray-50 hover:text-[#ed6503]"
                    onClick={() => setShowAdminMenu(false)}
                  >
                    <FaPlus className="mr-2" />
                    Add Vacancy
                  </Link>
                  <Link 
                    to="/add-user" 
                    className="flex items-center px-4 py-2 text-[#080366] hover:bg-gray-50 hover:text-[#ed6503]"
                    onClick={() => setShowAdminMenu(false)}
                  >
                    <FaUser className="mr-2" />
                    Add User
                  </Link>
                </div>
              )}
            </div>
          )}

          {/* Logout Button */}
          <button
            onClick={() => setShowLogoutConfirm(true)}
            className="flex items-center text-[#080366] hover:text-[#ed6503] transition-colors border border-[#080366] hover:border-[#ed6503] rounded-lg px-4 py-2"
          >
            <FaSignOutAlt className="mr-2" />
            Logout
          </button>
        </nav>

        {/* Mobile Menu Toggle */}
        <button
          className="md:hidden text-2xl text-[#080366] hover:text-[#ed6503] transition-colors"
          onClick={toggleMobileMenu}
          aria-label="Toggle mobile menu"
        >
          {isMobileMenuOpen ? <FaTimes /> : <FaBars />}
        </button>
      </div>

      {/* Mobile Sidebar */}
      {isMobileMenuOpen && (
        <div className="md:hidden bg-gray-100 py-4 px-6">
          <nav className="flex flex-col space-y-4 font-medium">
            {/* Common Navigation Items */}
            <Link to="/" className="flex items-center text-[#080366] hover:text-[#ed6503] transition-colors">
              <FaHome className="mr-2" />
              Home
            </Link>
            <Link to="/candidate-management" className="flex items-center text-[#080366] hover:text-[#ed6503] transition-colors">
              <FaSearch className="mr-2" />
              Candidates
            </Link>
            <Link to="/upload-resume" className="flex items-center text-[#080366] hover:text-[#ed6503] transition-colors">
              <FaUpload className="mr-2" />
              Upload Resume
            </Link>
            <Link to="/vacancies" className="flex items-center text-[#080366] hover:text-[#ed6503] transition-colors">
              <FaBriefcase className="mr-2" />
              View Vacancies
            </Link>

            {/* Admin Menu Items */}
            {role === 'superadmin' && (
              <>
                <div className="border-t border-gray-300 pt-4">
                  <div className="text-sm text-gray-500 mb-2">Admin Actions</div>
                  <Link to="/profile" className="flex items-center text-[#080366] hover:text-[#ed6503] transition-colors">
                    <ImProfile className="mr-2" />
                    Add Profile
                  </Link>
                  <Link to="/add-vacancy" className="flex items-center text-[#080366] hover:text-[#ed6503] transition-colors mt-4">
                    <FaPlus className="mr-2" />
                    Add Vacancy
                  </Link>
                  <Link to="/add-user" className="flex items-center text-[#080366] hover:text-[#ed6503] transition-colors mt-4">
                    <FaUser className="mr-2" />
                    Add User
                  </Link>
                </div>
              </>
            )}

            {/* Mobile Logout Button */}
            <button
              onClick={() => setShowLogoutConfirm(true)}
              className="flex items-center text-[#080366] hover:text-[#ed6503] transition-colors w-full mt-4 pt-4 border-t border-gray-300"
            >
              <FaSignOutAlt className="mr-2" />
              Logout
            </button>
          </nav>
        </div>
      )}

      {/* Logout Confirmation Modal */}
      {showLogoutConfirm && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-white rounded-lg p-6 max-w-sm mx-4">
            <div className="flex items-center justify-center text-[#080366] mb-4">
              <FaUser className="text-4xl" />
            </div>
            <h3 className="text-xl font-semibold text-center mb-4">Confirm Logout</h3>
            <p className="text-gray-600 text-center mb-6">Are you sure you want to logout?</p>
            <div className="flex justify-center space-x-4">
              <button
                onClick={() => setShowLogoutConfirm(false)}
                className="px-4 py-2 border border-gray-300 rounded-lg hover:bg-gray-50 transition-colors"
              >
                Cancel
              </button>
              <button
                onClick={handleLogout}
                className="px-4 py-2 bg-[#ed6503] text-white rounded-lg hover:bg-[#d95a02] transition-colors"
              >
                Logout
              </button>
            </div>
          </div>
        </div>
      )}
    </header>
  );
};

export default Header;